var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(!_vm.loading)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('tarjeta-datos',{attrs:{"datos":[
          {
            nombre: 'CUPS',
            valor: [_vm.datos.CodigoCUPS, _vm.datos.NombreCalle]
              .filter(function (item) { return item != null; })
              .join(' - '),
          },
          { nombre: 'Codigo CUPS', valor: _vm.datos.CodigoCUPS } ]}})],1),_c('v-col',{staticClass:"col-lg-4 col-sm-6",attrs:{"cols":"12"}},[_c('tarjeta-datos',{attrs:{"header":"","titulo":"Dirección","icon":"lightbulb","datos":[
          { nombre: 'Provincia', valor: _vm.datos.TextoProvincia },
          { nombre: 'Ciudad', valor: _vm.datos.TextoCiudad },
          { nombre: 'Calle', valor: _vm.datos.NombreCalle },
          { nombre: 'Número', valor: _vm.datos.Numero },
          { nombre: 'Portal', valor: _vm.datos.TextoPortal },
          { nombre: 'Aclarador', valor: _vm.datos.Aclarador },
          { nombre: 'Distribuidora', valor: _vm.datos.Distribuidora } ]}}),_c('tarjeta-datos',{staticClass:"mt-2",attrs:{"header":"","titulo":"Varios","icon":"chevron-double-down","datos":[
          { nombre: 'Ref Catastral', valor: _vm.datos.RefCatastral },
          { nombre: 'CNAE', valor: _vm.datos.TextoCnae },
          { nombre: 'Observaciones', valor: _vm.datos.Observaciones } ]}})],1),_c('v-col',{staticClass:"col-lg-8 col-sm-6",attrs:{"cols":"12"}},[_c('tarjeta-datos',{attrs:{"header":"","titulo":"Boletín","icon":"note"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-0 col-md-6",attrs:{"cols":"12"}},[_c('tarjeta-datos',{attrs:{"borderless":"","datos":[
                { nombre: 'Nº Boletín', valor: _vm.datos.NumBoletin },
                { nombre: 'Titulación', valor: _vm.datos.Titulacion },
                { nombre: 'Colegio', valor: _vm.datos.Colegio },
                {
                  nombre: 'Titular Certificado',
                  valor: _vm.datos.TitularCertificado,
                },
                { nombre: 'Director Obra', valor: _vm.datos.DirectorObra },
                { nombre: 'Org. Control', valor: _vm.datos.Organismo },
                { nombre: 'Nº CCI', valor: _vm.datos.CCI },
                { nombre: 'Modalidad', valor: _vm.datos.Modalidad },
                {
                  nombre: 'Observaciones Servicios Territoriales',
                  valor: _vm.datos.ObsTerritorial,
                } ]}})],1),_c('v-col',{staticClass:"pa-0 col-md-6",attrs:{"cols":"12"}},[_c('tarjeta-datos',{attrs:{"borderless":"","datos":[
                { nombre: 'Potencia Max Boletin', valor: _vm.datos.PotMax },
                { nombre: 'Instalación', valor: _vm.datos.FechaIns },
                { nombre: 'Vigencia', valor: _vm.datos.FechaVigencia },
                { nombre: 'Fecha Favorable', valor: _vm.datos.FechaOk },
                { nombre: null, valor: '' },
                { nombre: 'Nº Colegio', valor: _vm.datos.NumColegiado },
                { nombre: 'Nº Notificación', valor: _vm.datos.Notificacion },
                { nombre: 'Categoría', valor: _vm.datos.Categoria },
                {
                  nombre: 'Observaciones Instalación',
                  valor: _vm.datos.ObsInstalacion,
                } ]}})],1)],1)],1)],1)],1):_c('v-row',[_c('v-overlay',{attrs:{"absolute":""}},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":"","color":"primary"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }